import styles from '../InternalExternalDetail.module.css'
import Icon from './Icon'

const EduCard = ({ title, meta, year, iconType, iconName = 'building' }) => (
  <div className={styles.eduCard}>
    <div className={styles.eduIconWrap}>
      {iconType === 'roundBadge' ? (
        <div className={styles.eduRoundBadge}>
          <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 0L0 6L4 8.18V14.18L11 18L18 14.18V8.18L20 7.09V14H22V6L11 0ZM17.82 6L11 9.72L4.18 6L11 2.28L17.82 6ZM16 13L11 15.72L6 13V9.27L11 12L16 9.27V13Z" fill="#1E90FF"/>
          </svg>
        </div>
      ) : (
        <div className={styles.eduBuildingIcon}>
          <Icon name={iconName} />
        </div>
      )}
    </div>

    <div className={styles.eduBody}>
      <h4 className={styles.eduTitle}>{title}</h4>
      <p className={styles.eduMeta}>{meta}</p>
      <span className={styles.eduYear}>{year}</span>
    </div>
  </div>
)

export default EduCard
